import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const selectedSize = product?.size?.[0] || "";
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="container">
          <div className="product-detail__not-found">
            <h2>Product not found</h2>
            <Link to="/shop" onClick={toTop}>
              Back to Shop
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail">
      <div className="container">
        <div className="product-detail__breadcrumb">
          <Link to="/" onClick={toTop}>
            Home
          </Link>
          <span>&nbsp;/&nbsp;</span>
          <span>{product.category}</span>
          <span>&nbsp;/&nbsp;</span>
          <span>{product.name}</span>
        </div>

        <div className="product-detail__content">
          <div className="product-detail__gallery">
            <div className="product-detail__main-image">
              <img
                src={product.images?.[selectedImage] || product.image}
                alt={product.name}
              />
            </div>
            {product.images && product.images.length > 1 && (
              <div className="product-detail__thumbnails">
                {product.images.map((img, idx) => (
                  <div
                    key={idx}
                    className={`product-detail__thumbnail ${
                      selectedImage === idx ? "active" : ""
                    }`}
                    onClick={() => setImage(idx)}
                  >
                    <img src={img} alt={`${product.name} ${idx + 1}`} />
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="product-detail__info">
            <div className="product-detail__shipping">
              Free shipping over $40
            </div>

            <h1 className="product-detail__title">{product.name}</h1>

            <div className="product-detail__brand">pittleforestandco</div>

            <div className="product-detail__price">${product.price}</div>

            <div className="product-detail__tax">Tax included.</div>

            {product.colors && product.colors.length > 0 && (
              <div className="product-detail__color">
                <div className="product-detail__label">Color</div>
                <div className="product-detail__color-options">
                  {product.colors.map((color, idx) => (
                    <button
                      key={idx}
                      className={`product-detail__color-option ${
                        selectedColor === color ? "active" : ""
                      }`}
                      onClick={() => setSelectedColor(color)}
                    >
                      {color}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div className="product-detail__quantity">
              <div className="product-detail__label">Quantity</div>
              <div className="product-detail__quantity-selector">
                <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>
                  −
                </button>
                <span>{quantity}</span>
                <button onClick={() => setQuantity(quantity + 1)}>+</button>
              </div>
            </div>

            <button
              className="product-detail__add-to-cart"
              onClick={handleAddToCart}
            >
              Add to cart
            </button>

            <div className="product-detail__pickup">
              <span className="check-icon">✓</span>
              Pickup available at pittleforestandco Online - Brighton
              <div className="pickup-details">Usually ready in 24 hours</div>
              <div className="pickup-link">View store information</div>
            </div>

            <div className="product-detail__accordion">
              <div className="accordion-item">
                <button className="accordion-header">
                  <span>📦 Shipping &amp; Returns</span>
                </button>
                <div className="accordion-content">
                  <p>
                    Choose from Royal Mail 48 hour fully tracked service or DPD
                    Express delivery.
                  </p>
                  <p>Standard UK shipping is free when you spend $40.</p>
                  <p>
                    Express Next Working Day UK shipping is free when you spend
                    $100.
                  </p>
                  <p>
                    Place your order by 12pm business day for same day dispatch.
                    Please note that international orders may incur customs
                    charges. Please read our shipping page carefully before
                    placing an order. Find out about our returns policy{" "}
                    <Link to="/returns" onClick={toTop}>
                      here
                    </Link>
                    .
                  </p>
                </div>
              </div>
              <div className="accordion-item">
                <button className="accordion-header">
                  <span>🎁 Gift Wrapping</span>
                </button>
                <div className="accordion-content">
                  <p>
                    Have your items arrive gift-ready by selecting our wrapping
                    service at checkout or adding a gift box to your cart. You
                    can find out more{" "}
                    <Link to="/" onClick={toTop}>
                      here
                    </Link>
                    .
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="product-detail__description">
          <h2>Product description</h2>
          {product.description &&
            product.description.map((paragraph, idx) => (
              <p key={idx}>{paragraph}</p>
            ))}

          {product.Features && product.Features.length > 0 && (
            <>
              <h3>Key specs</h3>
              <ul>
                {product.Features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
